import { useContext } from "react";
//import ReactPropTypes from 'prop-types';
import { FormContext } from "./Form";

export function Label({
    name,
    htmlFor = null,
    className = "",
    children,
}) {

    // Get information from the parent Form wrapper
    const { formId } = useContext(FormContext);

    const id = htmlFor ? htmlFor : `${name}-${formId}`;

    return(
        <label className={className} htmlFor={id}>
            {children}
        </label>
    );
}



// Label.propTypes = {
//     helpText: ReactPropTypes.string,
//     placement: ReactPropTypes.oneOf(['right', 'left', 'bottom', 'top', 'auto']),
//     iconClass: ReactPropTypes.string,
//     children: ReactPropTypes.node,
//     className: ReactPropTypes.string,
// }
